var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgImage = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M20.25,13.1893398 L20.25,5 C20.25,4.30964406 19.6903559,3.75 19,3.75 L5,3.75 C4.30964406,3.75 3.75,4.30964406 3.75,5 L3.75,19 C3.75,19.5943316 4.16478539,20.0917849 4.72066804,20.2186718 L15.4696699,9.46966991 C15.7625631,9.1767767 16.2374369,9.1767767 16.5303301,9.46966991 L20.25,13.1893398 Z M20.25,15.3106602 L16,11.0606602 L6.81066017,20.25 L19,20.25 C19.6903559,20.25 20.25,19.6903559 20.25,19 L20.25,15.3106602 Z M5,2.25 L19,2.25 C20.5187831,2.25 21.75,3.48121694 21.75,5 L21.75,19 C21.75,20.5187831 20.5187831,21.75 19,21.75 L5,21.75 C3.48121694,21.75 2.25,20.5187831 2.25,19 L2.25,5 C2.25,3.48121694 3.48121694,2.25 5,2.25 Z M8.5,10.75 C7.25735931,10.75 6.25,9.74264069 6.25,8.5 C6.25,7.25735931 7.25735931,6.25 8.5,6.25 C9.74264069,6.25 10.75,7.25735931 10.75,8.5 C10.75,9.74264069 9.74264069,10.75 8.5,10.75 Z M8.5,9.25 C8.91421356,9.25 9.25,8.91421356 9.25,8.5 C9.25,8.08578644 8.91421356,7.75 8.5,7.75 C8.08578644,7.75 7.75,8.08578644 7.75,8.5 C7.75,8.91421356 8.08578644,9.25 8.5,9.25 Z"
  }));
};
export default SvgImage;